import React from "react";
import { showError } from "../../store/notifications/actions";
import { updateCurrentFrameData } from "../../store/storyline/actions";
import { Button, Toolbar } from "../../shared/components";
import { UnControlled as CodeMirror } from "react-codemirror2"
import "codemirror/mode/javascript/javascript";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/markdown-fold";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { jsonParseReviver } from "../../shared/api-client";
import { useThunkDispatch } from "../../store";

const EDITOR_OPTIONS = {
    mode: { name: "javascript", json: true },
    lineNumbers: true,
    theme: "material",
    foldGutter: true,
    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]
};

type FrameDataProps = {
    frameData: object;
};

function FrameData(props: FrameDataProps) {
    const { frameData } = props;
    const editorRef = React.useRef(null);
    const dispatch = useThunkDispatch();

    const applyFrameDataChange = React.useCallback(() => {
        try {
            const newFrameData = JSON.parse(editorRef.current.doc.getValue(), jsonParseReviver);
            dispatch(updateCurrentFrameData(newFrameData));
        }
        catch (ex) {
            dispatch(showError(`Failed to parse JSON: ${ex}`));
        }
    }, []);

    const editorDidMount = React.useCallback((editor) => {
        editorRef.current = editor;
        setTimeout(() => editor.execCommand("goDocStart"));
    }, []);

    return (
        <>
            <div className="framedata-panel">
                <CodeMirror
                    value={JSON.stringify(frameData, null, 2)}
                    options={EDITOR_OPTIONS}
                    editorDidMount={editorDidMount}
                />

                <Toolbar className="d-flex flex-row align-items-center justify-content-center gap-2">
                    <Button color="secondary" variant="contained" onClick={applyFrameDataChange}>Apply Changes</Button>
                </Toolbar>
            </div>
        </>
    );
}

export default React.memo(FrameData);